/* Nordweg PDP — comportamento das seções nw-* (galeria, carrosséis, acordeões, barra fixa) */
(function () {
  if (window.NW_PDP_LOADED) return;
  window.NW_PDP_LOADED = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Acordeões */
    document.querySelectorAll('.nw-accordion__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.nw-accordion__item').classList.toggle('is-open');
      });
    });

    /* Galeria principal */
    document.querySelectorAll('[data-nw-gallery]').forEach(function (gal) {
      var track = gal.querySelector('.nw-gallery__track');
      var slides = gal.querySelectorAll('.nw-gallery__slide');
      var thumbs = gal.querySelectorAll('.nw-gallery__thumb');
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }
      gal.querySelectorAll('.nw-gallery__arrow--prev').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
      gal.querySelectorAll('.nw-gallery__arrow--next').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      gal.nwGo = go;
      go(0);
    });

    /* Avaliações: transforma o widget Judge.me em cards de carrossel */
    document.querySelectorAll('[data-nw-reviews]').forEach(function (sec) {
      var root = sec.closest('.nw-reviews') || sec;
      /* fallback de estrelas quando o CSS do Judge.me não carregou */
      var star = sec.querySelector('.jdgm-star');
      if (star) {
        var ff = getComputedStyle(star).fontFamily || '';
        if (ff.indexOf('JudgemeStar') === -1) root.classList.add('nw-stars-fallback');
      } else {
        root.classList.add('nw-stars-fallback');
      }
      sec.querySelectorAll('.jdgm-rev').forEach(function (rev) {
        /* data de "2026-07-06 21:25:36 UTC" para 06/07/2026 (e remove o spinner do Judge.me) */
        var ts = rev.querySelector('.jdgm-rev__timestamp');
        if (ts) {
          ts.classList.remove('jdgm-spinner');
          if (!ts.textContent.trim()) {
            var raw = ts.getAttribute('data-content') || '';
            var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (m) ts.textContent = m[3] + '/' + m[2] + '/' + m[1];
          }
        }
        /* esconde título vazio (evita "." órfão) */
        var title = rev.querySelector('.jdgm-rev__title');
        if (title && title.textContent.trim().length < 2) title.style.display = 'none';
        /* botão "avaliação completa" */
        if (!rev.querySelector('.nw-rev-more')) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nw-rev-more';
          btn.textContent = 'Avaliação completa';
          btn.addEventListener('click', function () { rev.classList.toggle('is-expanded'); });
          rev.appendChild(btn);
        }
      });
    });

    /* Carrosséis de cards / mídia (scroll-snap + setas) */
    document.querySelectorAll('[data-nw-carousel]').forEach(function (car) {
      /* o track é buscado no clique: o widget do Judge.me pode ser montado
         depois deste script, e as setas precisam funcionar de qualquer forma */
      var getTrack = function () {
        return car.querySelector('[data-nw-track]') || car.querySelector('.jdgm-rev-widg__reviews');
      };
      var step = function (track) {
        var slide = track.querySelector(':scope > *');
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 22;
        return slide ? slide.getBoundingClientRect().width + gap : 400;
      };
      var move = function (dir) {
        var track = getTrack();
        if (!track) return;
        var left = track.scrollLeft + dir * step(track);
        if (typeof track.scrollTo === 'function') track.scrollTo({ left: left, behavior: 'smooth' });
        else track.scrollLeft = left;
      };
      car.querySelectorAll('[data-nw-prev]').forEach(function (b) { b.addEventListener('click', function () { move(-1); }); });
      car.querySelectorAll('[data-nw-next]').forEach(function (b) { b.addEventListener('click', function () { move(1); }); });
    });

    /* Variantes (swatches) */
    document.querySelectorAll('[data-nw-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-nw-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInputs = root.querySelectorAll('input[name="id"]');
      var priceEls = root.querySelectorAll('[data-nw-price]');
      var instEls = root.querySelectorAll('[data-nw-installments]');
      var nameEls = root.querySelectorAll('[data-nw-swatch-name]');
      var moneyFmt = function (cents) {
        var v = (cents / 100);
        var s = v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return 'R$ ' + s;
      };
      root.querySelectorAll('.nw-swatch input').forEach(function (input) {
        input.addEventListener('change', function () {
          root.querySelectorAll('.nw-swatch').forEach(function (s) { s.classList.toggle('is-active', s.contains(input)); });
          var value = input.value;
          var v = variants.find(function (x) { return x.options.indexOf(value) !== -1 && x.available; }) ||
                  variants.find(function (x) { return x.options.indexOf(value) !== -1; });
          if (!v) return;
          idInputs.forEach(function (el) { el.value = v.id; });
          priceEls.forEach(function (el) { el.textContent = moneyFmt(v.price); });
          instEls.forEach(function (el) {
            var n = parseInt(el.getAttribute('data-nw-installments'), 10) || 10;
            el.querySelector('[data-nw-inst-value]').textContent =
              (v.price / n / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          });
          nameEls.forEach(function (el) { el.textContent = value; });
          if (v.featured_image && v.featured_image.src) {
            var gal = root.querySelector('[data-nw-gallery]');
            if (gal) {
              var slides = gal.querySelectorAll('.nw-gallery__slide img');
              for (var k = 0; k < slides.length; k++) {
                var a = (slides[k].getAttribute('src') || '').split('?')[0].split('/').pop().toLowerCase();
                var b = (v.featured_image.src || '').split('?')[0].split('/').pop().toLowerCase();
                if (a === b) { gal.nwGo(k); break; }
              }
            }
          }
        });
      });

      /* sincroniza cor/foto/preco no carregamento, respeitando o parametro variant da URL */
      var qsId = new URLSearchParams(location.search).get('variant');
      var qv = qsId ? variants.find(function (x) { return String(x.id) === String(qsId); }) : null;
      var initInput = null;
      root.querySelectorAll('.nw-swatch input').forEach(function (i) {
        if (qv && qv.options.indexOf(i.value) !== -1) initInput = i;
      });
      if (!initInput) initInput = root.querySelector('.nw-swatch input:checked');
      if (initInput) {
        initInput.checked = true;
        setTimeout(function () { initInput.dispatchEvent(new Event('change', { bubbles: true })); }, 0);
      }
    });

    /* Barra fixa de compra */
    var bar = document.querySelector('.nw-stickybar');
    var hero = document.querySelector('.nw-hero');
    if (bar && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
      var btn = bar.querySelector('.nw-stickybar__btn');
      if (btn) btn.addEventListener('click', function () {
        var form = document.querySelector('.nw-hero form[action*="/cart/add"]');
        if (form) form.querySelector('[type="submit"]').click();
      });

      /* mobile: espelha as cores do buybox no lado esquerdo da barra fixa */
      var swSrc = document.querySelector('.nw-hero .nw-swatches');
      var info = bar.querySelector('.nw-stickybar__info');
      if (swSrc && info && !info.querySelector('.nw-stickybar__swatches')) {
      var wrap = document.createElement('div');
      wrap.className = 'nw-stickybar__swatches';
      swSrc.querySelectorAll('.nw-swatch').forEach(function (lb) {
      var inp = lb.querySelector('input');
      var dot = lb.querySelector('.nw-swatch__dot');
      if (!inp || !dot) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nw-swatch nw-stickybar__swatch' + (inp.checked ? ' is-active' : '');
      b.setAttribute('aria-label', inp.value);
      b.setAttribute('data-nw-sticky-swatch', inp.value);
      b.innerHTML = '<span class="nw-swatch__dot" style="' + (dot.getAttribute('style') || '') + '"></span>';
      b.addEventListener('click', function () {
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrap.appendChild(b);
      });
      info.appendChild(wrap);
      swSrc.querySelectorAll('.nw-swatch input').forEach(function (i) {
      i.addEventListener('change', function () {
      if (!i.checked) return;
      wrap.querySelectorAll('.nw-stickybar__swatch').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-nw-sticky-swatch') === i.value);
      });
      });
      });
      }
      /* o botao do Intercom some depois da primeira dobra e volta quando o usuario retorna ao topo */
      var syncIntercom = function () {
      document.documentElement.classList.toggle('nw-hide-intercom', bar.classList.contains('is-visible'));
      };
      if ('MutationObserver' in window) {
      new MutationObserver(syncIntercom).observe(bar, { attributes: true, attributeFilter: ['class'] });
      }
      syncIntercom();
    }
  });
})();